import { Component, OnInit } from '@angular/core';
import { FilterListTopFilterComponent } from 'gung-list';

@Component({
    selector: 'colmec-filter-list-top-filter',
    templateUrl: './colmec-filter-list-top-filter.component.html',
    styleUrls: ['./colmec-filter-list-top-filter.component.scss'],
    standalone: false
})
export class ColmecFilterListTopFilterComponent extends FilterListTopFilterComponent { }
